module.exports = __webpack_public_path__ + "img/malt.8b40a2bd.svg";